import { MESSAGING_KEY } from '../constants';
import { reducer } from './reducer';
import { sagas } from './sagas';


export const state = {
    reducer: {
        [MESSAGING_KEY]: reducer,
    },
    sagas,
};

export * as MessagingTypes from './types';
export * from './utils';
